import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import HikariStudy from "@/pages/HikariStudy";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/lib/auth";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect the OAuth fragment synchronously during render so the
  // session_id is processed BEFORE any auth check fires.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HikariStudy />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App" data-testid="hikari-app">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0D2340",
            color: "#E8F0F7",
            border: "1px solid rgba(0,191,165,0.35)",
            fontFamily: "Barlow, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
